/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  WorkloadFormBlock,
  WorkloadFormBlock$inboundSchema,
} from "./workloadformblock.js";

/**
 * One screen of a custom flow's form.
 */
export type WorkloadFormStep = {
  /**
   * Rendered in order.
   */
  blocks: Array<WorkloadFormBlock>;
  /**
   * Stable within the form.
   */
  id: string;
  /**
   * Heads the step.
   */
  title: string;
};

/** @internal */
export const WorkloadFormStep$inboundSchema: z.ZodMiniType<
  WorkloadFormStep,
  unknown
> = z.object({
  blocks: z.array(WorkloadFormBlock$inboundSchema),
  id: z.string(),
  title: z.string(),
});

export function workloadFormStepFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadFormStep, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadFormStep$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadFormStep' from JSON`,
  );
}
